import React, { useState, useEffect } from "react";
import { TextFieldProps, TextField } from "@material-ui/core";
import { size } from '../util';
import client from '../../thunks/client';


export default function FolderField(props: TextFieldProps) {
  const {value, onChange} = props;
  const [freespace, setFreespace] = useState('');
  const [message, setMessage] = useState('');

  const fetchFreeSpace = async () => {
    if (!value) {
      setFreespace('N/A');
    }
    try {
      const res = await client.get("/freespace", { qs: { path: value } });
      setFreespace(size(res.data as number));
      if (res.data < 0) {
        setMessage('Invalid Path');
      } else {
        setMessage('');
      }
    } catch (e: any) {
      setMessage(e.message);
    }
  }

  const handleBlur = () => {
    fetchFreeSpace();
  }

  useEffect(() => {
    fetchFreeSpace();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <TextField
      margin="dense"
      variant="outlined"
      fullWidth
      value={value}
      error={!value || !!message}
      label={`Freespace: ${message || freespace}`}
      onBlur={handleBlur}
      onChange={onChange}
    />
  );
}